import ApiEventHandler from '../schema/ApiEventHandler';
import { OutlookEventDispId } from '../schema/OutlookEventDispId';

export type ActiveApiEvents = {
    [controlId: string]: { [dispId: number]: ApiEventHandler };
};

const allActiveApiEvents: ActiveApiEvents = {};

export function getApiEventHandler(controlId: string, dispId: OutlookEventDispId): ApiEventHandler {
    if (allActiveApiEvents[controlId] && allActiveApiEvents[controlId][dispId]) {
        return allActiveApiEvents[controlId][dispId];
    }
    return null;
}

export function setApiEventHandler(
    controlId: string,
    dispId: OutlookEventDispId,
    newHandler: ApiEventHandler
): void {
    if (!allActiveApiEvents[controlId]) {
        allActiveApiEvents[controlId] = {};
    }
    allActiveApiEvents[controlId][dispId] = newHandler;
}

export function deleteApiEventHandler(controlId: string, dispId: OutlookEventDispId): void {
    if (allActiveApiEvents[controlId] && allActiveApiEvents[controlId][dispId]) {
        delete allActiveApiEvents[controlId][dispId];
    }
}

export function deleteAllApiEventHandlers(controlId: string): void {
    delete allActiveApiEvents[controlId];
}

export function isControlRegistered(controlId: string, dispId: OutlookEventDispId): boolean {
    return !!getApiEventHandler(controlId, dispId);
}
